<script lang="ts" setup>
import { TripDateField } from "@/constants/trip";
import { computed, ref } from "vue";

const sortOptions = [
  { field: TripDateField.NextStopSoonest, label: "Next stop time: ↑ Soonest" },
  { field: TripDateField.NextStopLatest, label: "Next stop time: ↓ Latest" },
  { field: TripDateField.ETASoonest, label: "ETA: ↑ Soonest" },
  { field: TripDateField.ETALatest, label: "ETA: ↓ Latest" },
  { field: TripDateField.LastCheckCallSoonest, label: "Last check call: ↑ Soonest" },
  { field: TripDateField.LastCheckCallLatest, label: "Last check call: ↓ Latest" },
  { field: TripDateField.CheckCallTimersSoonest, label: "Check calls timer: ↑ Soonest" },
  { field: TripDateField.CheckCallTimerLatest, label: "Check calls timer: ↓ Latest" },
  { field: TripDateField.UpdateTimerSoonest, label: "Broker updates timer: ↑ Soonest" },
  { field: TripDateField.UpdateTimerLatest, label: "Broker updates timer: ↓ Latest" },
];

const sortOption = defineModel<TripDateField>({
  default: TripDateField.NextStopSoonest,
});

const isOpenMenu = ref<boolean>(false);

const currentOptionLabel = computed(() => {
  return sortOptions.find((item) => item.field === sortOption.value)?.label || "";
});

const emits = defineEmits<{
  (e: "update:modelValue", value: TripDateField): void;
}>();
</script>

<template>
  <v-menu v-model="isOpenMenu">
    <template #activator="{ props: menuProps }">
      <div class="d-flex align-center" v-bind="menuProps">
        <span>Sort by:</span>

        <span class="font-weight-500 text-grey-darken-3 ml-1">{{ currentOptionLabel }}</span>

        <v-icon
          :class="{
            rotated: !isOpenMenu,
          }"
          class="ml-1"
          >mdi-chevron-down</v-icon
        >
      </div>
    </template>

    <v-list color="primary">
      <v-list-item
        v-for="option in sortOptions"
        :key="option.field"
        :active="sortOption === option.field"
        @click="emits('update:modelValue', option.field)"
      >
        <v-list-item-title>{{ option.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style lang="scss" scoped>
.rotated {
  transform: rotate(-180deg);
  transition: 0.3s ease;
}
</style>
